import React from "react";
import ContactSection from "../components/ContactSection";
import CTASection from "../components/CTASection";

const ContactPage = () => {
  return (
    <>
      <ContactSection />
      <CTASection />
    </>
  );
};

export default ContactPage;
